import logo from './logo.svg';
import './App.css';
import Router from './router/Router';

function App() {
  return (
    <div className="App notranslate" translate="no">
      <Router />
    </div>
  );
}

export default App;
